query GetCsmInfo {
    csmInfo {
        csmType
        firstName
        calendlyLink
        emailAddress
        funFact
    }
}
